import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.sink_1 = sink;
        this.closed_1 = false;
        this.buffer_1 = new (Buffer())();
      }
      write_kzgu6x_k$(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.buffer_1.write_kzgu6x_k$(source, byteCount);
        this.emitCompleteSegments_5yum7g_k$();
        return Unit_instance;
      }
      write_nkn6vw_k$(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.buffer_1.write_nkn6vw_k$(byteString);
        return this.emitCompleteSegments_5yum7g_k$();
      }
      writeUtf8_9rv3au_k$(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.buffer_1.writeUtf8_9rv3au_k$(string);
        return this.emitCompleteSegments_5yum7g_k$();
      }
      writeUtf8_sgs1di_k$(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.buffer_1.writeUtf8_sgs1di_k$(string, beginIndex, endIndex);
        return this.emitCompleteSegments_5yum7g_k$();
      }
      writeByte_3m2t4h_k$(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.buffer_1.writeByte_3m2t4h_k$(b);
        return this.emitCompleteSegments_5yum7g_k$();
      }
      emitCompleteSegments_5yum7g_k$() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        var byteCount = this.buffer_1.completeSegmentByteCount_8y8ucz_k$();
        if (byteCount > 0n) {
          this.sink_1.write_kzgu6x_k$(this.buffer_1, byteCount);
        }
        return this;
      }
      flush_shahbo_k$() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if (this.buffer_1.size_1 > 0n) {
          this.sink_1.write_kzgu6x_k$(this.buffer_1, this.buffer_1.size_1);
        }
        this.sink_1.flush_shahbo_k$();
        return Unit_instance;
      }
      close_yn9xrc_k$() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.closed_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.buffer_1.size_1 > 0n) {
              this.sink_1.write_kzgu6x_k$(this.buffer_1, this.buffer_1.size_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.sink_1.close_yn9xrc_k$();
          } catch ($p_0) {
            if ($p_0 instanceof Error) {
              var e_0 = $p_0;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p_0;
            }
          }
          this.closed_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.sink_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
